import { _getStorage, _setStorage } from '@/utils/useLocalStorage';

export const TENANT_CLUSTER_MAP_STORAGE_KEY = 'tenantClusterMap';

export type TenantClusterMap = Record<string, string>;

const isValidStorageValue = (value?: string | null) =>
  Boolean(value && value !== 'undefined' && value !== ':tenant' && value !== ':cluster');

/** 路由 / 状态中的合法数据中心名（排除 undefined 字符串与占位符） */
export function isValidClusterName(value?: string | null) {
  return Boolean(value && value !== 'undefined' && value !== ':cluster');
}

export function getTenantClusterMap(): TenantClusterMap {
  const value = _getStorage(TENANT_CLUSTER_MAP_STORAGE_KEY, {});
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

export function getTenantClusterByTenant(tenant?: string | null) {
  if (!isValidStorageValue(tenant)) return undefined;
  return getTenantClusterMap()[tenant as string];
}

export function setTenantClusterForTenant(tenant?: string | null, cluster?: string | null) {
  if (!isValidStorageValue(tenant)) return;

  const tenantClusterMap = getTenantClusterMap();
  if (isValidClusterName(cluster)) {
    tenantClusterMap[tenant as string] = cluster as string;
  } else {
    delete tenantClusterMap[tenant as string];
  }

  _setStorage(TENANT_CLUSTER_MAP_STORAGE_KEY, tenantClusterMap);
}
